import React from "react";

const DrawerProviderCtx = React.createContext();
DrawerProviderCtx.displayName = "DrawerProviderCtx";

const DrawerProvider = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  return (
    <DrawerProviderCtx.Provider value={[drawerOpen, setDrawerOpen]}>
      {children}
    </DrawerProviderCtx.Provider>
  );
};

const useDrawer = () => React.useContext(DrawerProviderCtx);

export { DrawerProvider, useDrawer };
